import { FullPageCard } from 'components/layout/FullPageCard/FullPageCard';
import { Page } from 'components/layout/Page/Page';
import { useRouter } from 'next/router';

import { useForgotPassword } from 'components/views/pages/forgot-password/useForgotPassword';
import { ForgotResetFormik } from 'components/views/pages/forgot-password/ForgotResetFormik';
import { userNextRouteTransitions } from 'hooks/useNextRouteTransitions';
import { useUserQuery } from '@alluradirect/react';
import { useIsUserLoggedInRedirectSignup } from 'components/views/pages/signup/hooks/useIsUserLoggedInRedirectToManagment';

const ForgotPassword = () => {
  // if we're logged in we don't need to sign up
  const userQuery = useUserQuery();
  useIsUserLoggedInRedirectSignup(userQuery);

  // OK we should be here, continue...

  const router = useRouter();
  const { navigateToGuestLogIn } = userNextRouteTransitions();
  const forgotPassword = useForgotPassword({
    navigateOnResetPasswordSuccess: () => {
      navigateToGuestLogIn();
    },
  });

  const goBack = () => {
    if (forgotPassword.verified) {
      forgotPassword.setVerified(false);
    } else {
      router.back();
    }
  };

  return (
    <Page
      appSEOProps={{
        title: 'Forgot Password',
        description: 'Forgot password, recover account',
      }}
      headerProps={{
        logoOnly: true,
      }}
    >
      <FullPageCard goBack={goBack} step={{ title: 'Forgot Password?', step: 1, hasBack: true }} hasShadow={false}>
        <ForgotResetFormik {...forgotPassword} />
      </FullPageCard>
    </Page>
  );
};

export default ForgotPassword;
